"use strict";
const translate = require('./translate');
const alert = require('./alert');
const article = require('./article');
const brand = require('./brand');
const customerSubUnit = require('./customerSubUnit');
const activity = require('./activity');
const invite = require('./invite');
const email = require('./email');
const invoice = require('./invoice');
const order = require('./order');
const orderRow = require('./orderRow');
const cart = require('./cart');
const complaint = require('./complaint');
const oauthToken = require('./oauthToken');
const organization = require('./organization');
const priceList = require('./priceList');
const pricedArticle = require('./pricedArticle');
const purchaseOrder = require('./purchaseOrder');
const purchaseList = require('./purchaseList');
const shopConfig = require('./shopConfig');
const shopUser = require('./shopUser');
const supplier = require('./supplier');
const user = require('./user');
const userProfile = require('./userProfile');
const job = require('./job');
const stockTaking = require('./stockTaking');
const endCustomerInInventory = require('./end-customer-in-inventory');
const articleInInventory = require('./article-in-inventory');
const integration = require('./integration');
const validooArticle = require('./validooArticle');
const validooSubscription = require('./validooSubscription');
const validooCredential = require('./validooCredential');
const supplierSalesReport = require('./supplierSalesReport');
const endCustomerOrganization = require('./endCustomerOrganization');
const outgoingMessage = require('./outgoingMessage');
const failedActionCall = require('./failedActionCall');
const supplierCustomer = require('./supplierCustomer');
const supplierCustomerInOmsService = require('./supplierCustomerInOmsService');
const customerSubUnitInPcsService = require('./customerSubUnitInPCSService');
const articleInPcsService = require('./articleInPCSService');
const procurementList = require('./procurementList');
const procurementArticle = require('./procurementArticle');
const supplierConnection = require('./supplierConnection');
const supplierInPcsService = require('./supplierInPCSService');
const supplierCustomerInPcsService = require('./supplierCustomerInPcsService');
const label = require('./label');
const orderFullfillmentCenter = require('./orderFullfillmentCenter');
const organizationInOmsService = require('./organizationInOmsService');
const emailTemplateConfig = require('./emailTemplateConfig');
const organizationInPcsService = require('./organizationInPCSService');
const ofcInSupplierGateway = require('./ofcInSupplierGateway');
const ofcInCrm = require('./ofcInCrm');
const userInCrm = require('./userInCrm');
const copackAgreement = require('./copackAgreement');
const orderBrokerageAgreement = require('./orderBrokerageAgreement');
const entitySettlement = require('./entitySettlement');
const settlement = require('./settlement');
const mappingTemplate = require('./mappingTemplate');
const incomingMessage = require('./incomingMessage');
const stockArticle = require('./stockArticle');
const alcoholLicense = require('./alcoholLicense');
const categoryTree = require('./categoryTree');
const campaign = require('./campaign');
module.exports = {
    ...translate,
    activity,
    alert,
    article,
    pricedArticle,
    brand,
    customerSubUnit,
    invite,
    email,
    invoice,
    order,
    orderRow,
    cart,
    complaint,
    organization,
    priceList,
    purchaseOrder,
    purchaseList,
    shopConfig,
    user,
    shopUser,
    supplier,
    supplierSalesReport,
    job,
    stockTaking,
    endCustomerInInventory,
    articleInInventory,
    oauthToken,
    integration,
    validooArticle,
    validooSubscription,
    validooCredential,
    endCustomerOrganization,
    outgoingMessage,
    failedActionCall,
    userProfile,
    supplierCustomer,
    supplierCustomerInOmsService,
    customerSubUnitInPcsService,
    procurementList,
    procurementArticle,
    supplierConnection,
    supplierCustomerInPcsService,
    articleInPcsService,
    label,
    orderFullfillmentCenter,
    supplierInPcsService,
    organizationInOmsService,
    emailTemplateConfig,
    ofcInSupplierGateway,
    ofcInCrm,
    userInCrm,
    copackAgreement,
    orderBrokerageAgreement,
    organizationInPcsService,
    entitySettlement,
    settlement,
    mappingTemplate,
    incomingMessage,
    categoryTree,
    stockArticle,
    alcoholLicense,
    campaign,
};
